export const IS_AUTHENTICATED = 'IS_AUTHENTICATED'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export const SELF_USER_LOAD_SUCCESS = 'SELF_USER_LOAD_SUCCESS'

export const SELECT_ORGANIZATION = 'SELECT_ORGANIZATION'
export const DESELECT_ORGANIZATION = 'DESELECT_ORGANIZATION'